import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'

const HERO_BACKGROUND = '5c675819419a4a6771bd7ccfd9efcfdc.png'

const HeroBanner = () => (
  <section
    className="h-[500px] w-full bg-cover bg-center bg-no-repeat"
    style={{ backgroundImage: `url(${preFixImgUrl(HERO_BACKGROUND)})` }}
  >
    <div className="mx-auto flex h-full w-[1200px] flex-col items-center justify-center text-center text-white">
      <LangText
        lngKey="coupon.list.hero.title"
        className="text-[40px] font-bold leading-[48px]"
      />
      <LangText
        lngKey="coupon.list.hero.description"
        className="mt-[16px] text-[20px] leading-[28px] text-white/90"
      />
    </div>
  </section>
)

export default HeroBanner
